module.exports = __webpack_public_path__ + "img/violet_076.7eed43d7.png";